import {SearchOutlined} from "@ant-design/icons";
import {Button, Col, Form, Popover, Row, Space, Spin, Table} from "antd";
import {ExcelSVG, ListIconSVG} from "assets";
import {ColumnPopoverDisplay, InputFields} from "components/common";
import React, {useEffect, useState} from "react";
import {ColumnProps} from "types/models";
import {
  columns1,
  columns2,
  columns3,
  columns4,
  columns5,
  field,
  field2,
} from "./RenderXML.config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  setActiveKey,
  setButtonsHeader,
  setSiderKey,
} from "redux/reducer/common";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import moment from "moment";
import Notification from "components/common/notification/notification";
import {payService} from "api";
import dayjs from "dayjs";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {getTableOptions, saveTableOptions} from "helper/common";
import {setLoading} from "redux/reducer/medicineStore";
import ButtonPdf from "components/common/ButtonPdf/ButtonPdf";

const RenderXML = () => {
  const [data, setData] = useState([]);
  document.title = "Kết xuất XML";
  const [form] = Form.useForm();
  const [fields, setFields] = useState(field);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(false);
  const [scrolX, setScrolX] = useState(1500);
  const [columnCustom, setColumnCustom] = useState(columns1);
  const activeKey = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const mauXML = Form.useWatch("type", form);

  let savedTableOption = getTableOptions(
    "RENDERXML_TABLE",
    localStorage.getItem("username")
  );

  const defaultColumns = savedTableOption
    ? columnCustom.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnCustom;

  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(e => e.show == true)
  );

  const setShowColumns = showColumns => {
    saveTableOptions(
      "RENDERXML_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setActiveKey(tabKeys.XML.RENDER_XML));
    dispatch(setSiderKey("ketXuatXml"));
  }, [activeKey]);

  const getDataXML = async params => {
    setLoading(true);
    try {
      if (params.type === 8) {
        const newData2 = {
          ngayBatDau: `${params.thang}`,
          ngayKetThuc: `${params.nam}`,
          type: 8,
        };
        const response = await payService
          .getRenderXMLData(newData2)
          .then(res => {
            const newRes = res.data.data.map(e => ({
              ...e,
              key: e.id ?? `temp-key-${Math.random()}`,
            }));
            setData(newRes);
          });
      } else {
        const response = await payService.getRenderXMLData(params).then(res => {
          const newRes = res.data.data.map(e => ({
            ...e,
            key: e.id ?? `temp-key-${Math.random()}`,
          }));
          setData(newRes);
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleOnSearch = async () => {
    const data = await form.validateFields();
    const newData = {
      ...data,
      ngayBatDau: dayjs(data.ngayBatDau).format(FORMAT_TIME.dayFull),
      ngayKetThuc: dayjs(data.ngayKetThuc).format(FORMAT_TIME.dayFull),
    };
    const newData2 = {
      ...data,
      ngayBatDau: data.thang,
      ngayKetThuc: data.nam,
    };
    if (newData.type == 1) {
      setColumnCustom(columns1);
      setScrolX(1000);
    }
    if (newData.type == 2) {
      setColumnCustom(columns2);
      setScrolX(1000);
    }
    if (newData.type == 3) {
      setColumnCustom(columns3);
      setScrolX(1000);
    }
    if (newData.type == 4) {
      setColumnCustom(columns4);
      setScrolX(5500);
    }
    if (newData.type == 5) {
      setColumnCustom(columns1);
      setScrolX(1000);
    }
    if (newData.type == 6) {
      setColumnCustom(columns2);
      setScrolX(1000);
    }
    if (newData.type == 7) {
      setColumnCustom(columns5);
      setScrolX(1000);
    }
    if (newData.type == 8) {
      setColumnCustom(columns4);
      setScrolX(5500);
    }
    getDataXML(newData);
  };

  const handelOnExport = async (type?) => {
    const data = await form.validateFields();
    const newData = {
      ...data,
      ngayBatDau: dayjs(data.ngayBatDau).format(FORMAT_TIME.dayFull),
      ngayKetThuc: dayjs(data.ngayKetThuc).format(FORMAT_TIME.dayFull),
    };
    const newData2 = {
      thang: data.thang,
      nam: data.nam,
    };
    const newData3 = {
      type: 8,
      ngayBatDau: data.thang,
      ngayKetThuc: data.nam,
    };
    setLoading(true);
    // console.log('data config export', newData);
    try {
      let response;
      if (type === 999) {
        response = await payService.getDataExportXMLExcelC80(newData2);
      } else if (type === 8) {
        response = await payService.getDataExportXML(newData3);
      } else {
        response = await payService.getDataExportXML(newData);
      }
      // const response = await payService
      // .getDataExportXML(newData)
      // .then((res) => {
      var link = document.createElement("a");
      const url = window.URL.createObjectURL(response.data);
      link.href = url;
      link.download = `Báo cáo kết xuất XML.xlsx`;
      link.click();
      Notification("success", "Đã xuất file báo cáo");
      setLoading(false);
      // });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };
  const getReportFilePdf = async type => {
    const data = await form.validateFields();
    // const newData = {
    //   ...data,
    //   ngayBatDau: dayjs(data.ngayBatDau).format(FORMAT_TIME.dayFull),
    //   ngayKetThuc: dayjs(data.ngayKetThuc).format(FORMAT_TIME.dayFull),
    // };
    setLoading(true);
    // console.log('data config export', newData);
    const newDataC80 = {
      thang: data.thang,
      nam: data.nam,
    };
    const newData3 = {
      type: 8,
      ngayBatDau: data.thang,
      ngayKetThuc: data.nam,
    };
    try {
      let response;
      if (type === 8) {
        response = await payService.getDataExportXMLPDF(newData3);
      } else {
        response = await payService.getDataExportXMLPDFC80(newDataC80);
      }

      var link = document.createElement("a");
      const url = window.URL.createObjectURL(response.data);
      link.href = url;
      link.download = `Báo cáo kết xuất XML.pdf`;
      link.click();
      Notification("success", "Đã xuất file biểu mẫu");
      setLoading(false);
      // await payService
      //   [type === 9 ?getDataExportXMLPDF(newData) : getDataExportXMLPDFC80(newData)]
      //   .then((res) => {
      //     var link = document.createElement("a");
      //     const url = window.URL.createObjectURL(res.data);
      //     link.href = url;
      //     link.download = `Báo cáo kết xuất XML.pdf`;
      //     link.click();
      //     Notification(" ", "Đã xuất file biểu mẫu");
      //     setLoading(false);
      //   });
    } catch (error) {
      console.log("🚀 ~ getReportFilePdf ~ error:", error);
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file biểu mẫu");
    }
  };
  useEffect(() => {
    form.setFieldValue("ngayBatDau", dayjs());
    form.setFieldValue("ngayKetThuc", dayjs());
  }, []);

  const onSelectRow = (selectedRowKeys: React.Key[], selectedRows: any[]) => {
    setSelectedRowKeys([selectedRowKeys?.[selectedRowKeys?.length - 1]]);
  };
  const listYears = [];
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20;
  const endYear = currentYear + 100;
  for (let year = startYear; year <= endYear; year++) {
    listYears.push({
      value: year,
      label: year.toString(),
    });
  }

  useEffect(() => {
    if (mauXML === 999 || mauXML === 8) {
      setFields(field2);
    } else setFields(field);
  }, [mauXML]);

  return (
    <Spin spinning={loading}>
      <div className="render-data-xml page">
        <div className="main">
          <div className="container">
            <Space direction="vertical" style={{width: "100%"}}>
              <Form form={form}>
                <Row gutter={[16, 8]}>
                  <InputFields data={fields} />
                </Row>
              </Form>
              <Row justify={"end"}>
                <Button
                  htmlType="submit"
                  onClick={handleOnSearch}
                  type="primary"
                  icon={<SearchOutlined rev={0} />}
                >
                  Tìm kiếm
                </Button>
              </Row>
            </Space>
          </div>
          <div className="container">
            <Row justify={"space-between"} style={{marginBottom: "16px"}}>
              <Col>
                <div className="header">Danh sách</div>
              </Col>
              <Col>
                <Space>
                  {mauXML === 8 || mauXML === 999 ? ( // Nếu type là 8, ẩn nút Excel và hiển thị nút PDF
                    <>
                      <div>
                        <ButtonPdf
                          onClick={() =>
                            getReportFilePdf(mauXML === 8 ? 8 : 999)
                          }
                        ></ButtonPdf>
                      </div>
                      <div>
                        <Button
                          icon={<ExcelSVG />}
                          className="custom-btn"
                          onClick={() => handelOnExport(mauXML === 8 ? 8 : 999)}
                        >
                          Xuất báo cáo
                        </Button>
                      </div>
                    </>
                  ) : (
                    // Ngược lại, ẩn nút PDF và hiển thị nút Excel
                    <div>
                      <Button
                        icon={<ExcelSVG />}
                        className="custom-btn"
                        onClick={handelOnExport}
                      >
                        Xuất báo cáo
                      </Button>
                    </div>
                  )}
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={defaultColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      type="ghost"
                      className="btn-sub"
                      icon={<ListIconSVG />}
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                </Space>
              </Col>
            </Row>
            <CustomResizableTable
              setShowColumns={setShowColumns}
              bordered
              pagination={false}
              scroll={{x: scrolX}}
              columns={columnCustom}
              dataSource={data}
              rowSelection={{
                onChange: onSelectRow,
                selectedRowKeys: selectedRowKeys,
                type: "radio",
              }}
              setLoading={loading}
            ></CustomResizableTable>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default RenderXML;
